import script from "./FeatureList.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureList.vue?vue&type=script&setup=true&lang=js"

import "./FeatureList.vue?vue&type=style&index=0&id=f1651ed6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1651ed6"]])

export default __exports__